/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Zip/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Zip({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Address/Addresses/Content/Address/Edit/Content/Fields/Zip",
  isInvalid,
  onChange
  
}) {
let editAddressZipValueData = fromData.useDataValue({ viewPath,
context: 'edit_address',
path: 'zip',
})
let editAddressZipIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_address',
path: 'zip',
validate: fromValidate.zip,
})
let editAddressZipChangeData = fromData.useDataChange({ viewPath,
context: 'edit_address',
path: 'zip',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_address.zip"
 validate="/Data/validate.js zip"
 invalid={!editAddressZipIsValidData}
 value={editAddressZipValueData}
 onChange={editAddressZipChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="ZIP Code"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}